import { render, staticRenderFns } from "./svg_alert.vue?vue&type=template&id=bf401270"
import script from "./svg_alert.vue?vue&type=script&setup=true&lang=ts"
export * from "./svg_alert.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports